export const checkCharacterFile = (name: string | undefined) => {
  if (!name) return undefined;

  const splitName = name.split('.');
  const type = splitName[splitName.length - 1];

  if (type === 'glb') return 'glb';
  if (type === 'gltf') return 'gltf';

  return undefined;
};
